module.exports = __webpack_public_path__ + "static/media/due-port01.9943de95.jpg";